export default {
  "slots": {
    "base": "text-lg text-(--ui-text-highlighted) font-bold mt-6 mb-2 scroll-mt-[calc(24px+45px+var(--ui-header-height))] lg:scroll-mt-[calc(24px+var(--ui-header-height))] [&>a]:focus-visible:outline-(--ui-primary)",
    "link": ""
  }
}